// extracted by mini-css-extract-plugin
module.exports = {"walInput":"WalInput_walInput__3BSGF"};